"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLoadLocaleDayjs = exports.useGetLocaleDayjs = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const react_1 = require("react");
const dayjs_2 = require("../utils/dayjs");
const useGetLocaleDayjs = () => {
    const localeData = dayjs_1.default.localeData();
    return { ...localeData };
};
exports.useGetLocaleDayjs = useGetLocaleDayjs;
const useLoadLocaleDayjs = () => {
    (0, react_1.useEffect)(() => {
        (0, dayjs_2.loadLocaleDayjs)();
    }, []);
};
exports.useLoadLocaleDayjs = useLoadLocaleDayjs;
//# sourceMappingURL=useLocaleDayjs.js.map